import styled from 'styled-components';

export const SpinnerContainer = styled.div<{ absolute?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${({ absolute }) => (absolute ? 'absolute' : 'static')};
`;
